import { createContext } from "react";
import type { Session, User } from "@supabase/supabase-js";

export interface SessionContextValue {
  ready: boolean;
  session: Session | null;
  user: User | null;
  accessToken: string | null;
  configured: boolean;
  signInWithPassword: (email: string, password: string) => Promise<void>;
  signOut: () => Promise<void>;
}

export const SessionContext = createContext<SessionContextValue | null>(null);
